<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import TabDBDiff from "@/components/tabs/monitoring/tabDBDiff.vue";
import TabDBCopy from "@/components/tabs/monitoring/tabDBCopy.vue";
import Monitor from "@/services/Monitor";

export default {
  components: { Layout, PageHeader, TabDBDiff, TabDBCopy },
  data() {
    return {
      title: "Database Management",
      items: [],
      activeTab: "dbdiff",
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-tabs v-model="activeTab" class="mb-3">
      <b-tab title="Diff" key="dbdiff">
        <tab-d-b-diff/>
      </b-tab>

      <b-tab title="Copy" key="dbcopy">
        <tab-d-b-copy/>
      </b-tab>
    </b-tabs>
  </Layout>
</template>
